import { wrapLazyRoute } from "../lazy-loading/lazyWrapper";

export const routes = () => {
	return [
		{
			path: "/search",
			component: wrapLazyRoute(() => import("sd_articlesearch_ui/SearchPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				trackingName: "search",
				visibleForAnonymous: true,
			},
		},
		{
			path: "/category",
			childRoutes: [
				{
					path: "/category/*",
					component: wrapLazyRoute(() => import("sd_articlesearch_ui/CategoryPage"), {
						usesBootstrap: true,
					}),
					routeParam: {
						trackingName: "category",
						visibleForAnonymous: true,
					},
				},
			],
		},
		{
			path: "/promotions",
			component: wrapLazyRoute(() => import("sd_articlesearch_ui/PromotionsPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				trackingName: "promotions",
				visibleForAnonymous: true,
			},
		},
	];
};
